



















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { AssistanceForm } from '@/models/assistance'

// Components
import { FormCreateEditAssistance } from '@/components/assistance'

@Component({
    name: 'ModalCreateEditAssistance',
    components: {
        FormCreateEditAssistance
    }
})
export default class ModalCreateEditAssistance extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) assistance!: AssistanceForm
    @Prop({ type: String, default: '' }) type!: string

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nueva Asistencia'
        }
        return 'Editar Asistencia'
    }
}
